/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IDataPDF, IDataVoucherSuccessComponent } from '@pacifico/interfaces/components.interface';

@Component({
	selector: 'app-voucher-error',
	templateUrl: './voucher-error.component.html',
	styleUrls: ['./voucher-error.component.scss']
})
export class VoucherErrorComponent {
	@Input() dataVoucher!: IDataVoucherSuccessComponent;
	@Input() dataPdf!: IDataPDF;

	constructor(private _datePipe: DatePipe) {}
}
